import { ChangeDetectionStrategy, Component, effect, inject, input, untracked } from '@angular/core';
import { LOGO_INITIAL_STATE } from './cost-to-build-client-ui-logo.state';
import { LogoStore } from './cost-to-build-client-ui-logo.store';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [],
    providers: [LogoStore],
    selector: 'ctb-logo',
    styleUrl: './cost-to-build-client-ui-logo.scss',
    templateUrl: './cost-to-build-client-ui-logo.html',
})
export class CtbLogoComponent {
    readonly #store = inject(LogoStore);

    readonly alt = input<string>(LOGO_INITIAL_STATE.alt);
    readonly src = input<string>(LOGO_INITIAL_STATE.src);

    readonly state = this.#store.state;

    readonly syncStoreFromInputs = effect(() => {
        const nextState = { alt: this.alt(), src: this.src() };

        untracked(() => this.#store.setState(nextState));
    });
}
